import { ANY_RESOURCE_ID, ResourceType } from 'constants/index'
import { Resource } from 'types'

export function filterResource({
  isCabinOnlyConfiguration,
  resourceHasCalendarIntegration,
}: {
  isCabinOnlyConfiguration?: boolean
  resourceHasCalendarIntegration?: Record<string, boolean>
}) {
  const considerCalendarIntegration =
    resourceHasCalendarIntegration &&
    (() => {
      const resources = Object.keys(resourceHasCalendarIntegration)
      // only consider calendar integration if it's not just { "*": false }, because that means that availability request failed
      const isAvailabilitiesRequestFailed =
        resources.length === 1 && resources[0] === ANY_RESOURCE_ID && resourceHasCalendarIntegration[ANY_RESOURCE_ID] === false
      return resources.length > 0 && !isAvailabilitiesRequestFailed
    })()
  return function ({ type, id }: Resource) {
    return (
      (isCabinOnlyConfiguration ? type === ResourceType.CABIN : type !== ResourceType.CABIN) &&
      (considerCalendarIntegration ? resourceHasCalendarIntegration[id] : true)
    )
  }
}
